import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RmaUrlsService } from '@rma/generic/util/environment';
import { Observable } from 'rxjs';
import { SocialAssetDataType } from './social-asset-data-type';

@Injectable({
  providedIn: 'root',
})
export class SocialAssetService {
  private endpoints = {
    getSocialAsset: 'SocialAssets/{socialAssetDataType}/{theme}/{size}/Code-{entityCode}',
  };

  constructor(
    private readonly httpClient: HttpClient,
    private readonly rmaUrls: RmaUrlsService,
  ) {}

  public getSocialAssetUrl(socialAssetDataType: SocialAssetDataType, entityCode: string): Observable<string> {
    const endpoint = this.endpoints.getSocialAsset
      .replace('{socialAssetDataType}', socialAssetDataType)
      .replace('{size}', 'rectangle')
      .replace('{theme}', 'unbranded')
      .replace('{entityCode}', entityCode);

    return this.httpClient.get(this.rmaUrls.apiUrl(endpoint, 'Social'), { responseType: 'text' });
  }
}
